import { render, staticRenderFns } from "./XSelect.vue?vue&type=template&id=1390d6fb&"
import script from "./XSelect.vue?vue&type=script&lang=js&"
export * from "./XSelect.vue?vue&type=script&lang=js&"
import style0 from "./XSelect.vue?vue&type=style&index=0&id=1390d6fb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports